<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>卡密批次列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="openBatch()">添加</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="BatchData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" sortable prop="batchName" label="批次名称" width="160"></el-table-column>
            <el-table-column align="center" prop="state" label="状态" width="120" :formatter="State"></el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="getBatchxq(scope.row)">查看卡密批次详情</el-button>
                    <el-button size="mini" type="primary" @click="openBatch(scope.row)">修改</el-button>
                    <el-button size="mini" type="danger" @click="deleBatch(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 编辑界面 -->
        <el-dialog :title="tit" :visible.sync="editFormVisiible" width="40%">
            <el-form label-width="120px">
                <el-form-item label="批次名称" prop="batchName">
                    <el-input size="small" v-model="batchName" auto-complete="off" placeholder="请输入批次名称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="状态" prop="state">
                    <el-input size="small" v-model="state" auto-complete="off" placeholder="请输入批次描述"></el-input>
                </el-form-item> -->
                <el-form-item label="状态">
                    <el-select v-model="state" placeholder="请选择状态">
                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="addCardBatch()"
                    v-if="tit == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upCardBatch()"
                    v-if="tit == '修改'">修改</el-button>
            </div>
        </el-dialog>

        <!-- 批次详情 -->
        <el-dialog title="批次详情页：" :visible.sync="editFormDetails" width="40%">
            <el-form label-width="120px">
                <el-form-item label="批次名称：" prop="batchName">
                    <span v-html="this.Details.batchName"></span>
                </el-form-item>
                <el-form-item label="状态：" prop="state">
                    <span v-if="this.Details.state == 0">禁用</span>
                    <span v-if="this.Details.state == 1">启用</span>
                </el-form-item>
                <el-form-item label="创建时间：" prop="createTime">
                    {{ transformDate(this.Details.createTime) }}
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    getCardBatchList,
    getCardBatchInfo,
    addCardBatch,
    deleteCardBatch,
    upCardBatch
} from '../../api/userMG'
export default {
    data() {
        return {
            BatchData: [],
            editFormDetails: false,
            Details: [],
            editFormVisiible: false,
            loading: false,
            batchName: '',
            state: '',
            options: [{
                value: 0,
                label: '禁用'
            }, {
                value: 1,
                label: '启用'
            }],
        }
    },
    created() {
        this.getdata();
    },
    methods: {
        // 状态
        State: function (row) {
            if (row.state == 0) {
                return " 禁用"
            } else if (row.state == 1) {
                return "启用"
            }
        },
        // 删除
        deleBatch(row) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                let data = {
                    id: row.id
                }
                deleteCardBatch(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getdata(1)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 修改
        upCardBatch() {
            this.loading = true,
                upCardBatch({
                    id: this.id,
                    batchName: this.batchName,
                    state: this.state,
                }).then((res) => {
                    if (res.code == 200) {
                        this.loading = false
                        this.$message.success(res.msg)
                        this.editFormVisiible = false
                        this.getdata(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg)
                    }
                })
        },
        // 添加
        addCardBatch() {
            this.loading = true,
                addCardBatch({
                    batchName: this.batchName,
                    state: this.state,
                }).then((res) => {
                    if (res.code == 200) {
                        this.loading = false
                        this.$message.success(res.msg)
                        this.editFormVisiible = false
                        this.getdata(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg)
                    }
                })
        },
        // 打开编辑对话框
        openBatch(row) {
            this.editFormVisiible = true;
            if (row != undefined && row != "undefined") {
                this.tit = "修改",
                    this.id = row.id
                this.batchName = row.batchName
                this.state = row.state
            } else {
                this.tit = "添加"
                this.batchName = ""
                this.state = ""
            }
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },
        // 查看卡密批次详情
        getBatchxq(row) {
            this.loading = true;
            this.editFormDetails = true;
            let data = {
                id: row.id
            }
            getCardBatchInfo(data).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    });
                } else {
                    this.Details = res.data.data;
                    return;
                }
            })
        },
        // 获取批次数据
        getdata() {
            this.loading = true;
            getCardBatchList().then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.BatchData = res.data.list;
                    return;
                } else {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    })
                }
            })
        }
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/Cami/CamiBatch.vue